import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { generateId } from '../../../_core/utils/generate-id';

@Component({
  selector: 'opac-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {
  @ViewChild('tabEl', { static: true }) tabElement: ElementRef<HTMLButtonElement>;

  /**
   * Determines if tab is active
   */
  @Input() active: boolean = false;
  /**
   * Sets a badge on tab with value
   */
  @Input() badge?: number;
  /**
   * Sets tab id. Defaults to random string.
   */
  @Input() id: string = generateId();
  /**
   * Required linked panel name
   */
  @Input() panel!: string;

  /**
   * Emits when tab keydown event is triggered
   */
  @Output() keydown = new EventEmitter<KeyboardEvent>();
  /**
   * Joins keydown and click events to emit only one event
   */
  @Output() select = new EventEmitter<void>();
  /**
   * Emits when tab is clicked
   */
  @Output() click = new EventEmitter<void>();

  focus() {
    this.tabElement.nativeElement.focus();
  }
}
